import { render, staticRenderFns } from "./GiftPackageDetails.vue?vue&type=template&id=0e5e2241&scoped=true"
import script from "./GiftPackageDetails.vue?vue&type=script&lang=js"
export * from "./GiftPackageDetails.vue?vue&type=script&lang=js"
import style0 from "./GiftPackageDetails.vue?vue&type=style&index=0&id=0e5e2241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e2241",
  null
  
)

export default component.exports